import request from '@/utils/request'

export function fetchBusinessList(data) {
  return request({
    url: '/merchant-api/mch/business/list',
    method: 'post',
    data
  })
}

export function createBusiness(data) {
  return request({
    url: '/merchant-api/mch/business/create',
    method: 'post',
    data
  })
}

export function updateBusiness(data) {
  return request({
    url: '/merchant-api/mch/business/update',
    method: 'put',
    data
  })
}

export function fetchBusinessDetail(businessNo) {
  return request({
    url: `/merchant-api/mch/business/detail/${businessNo}`,
    method: 'get'
  })
}

export function searchBusinesses(data) {
  return request({
    url: '/merchant-api/mch/business/search',
    method: 'post',
    data
  })
}
